import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Icon, Row, Col } from 'antd'
import PropTypes from 'prop-types'
import typo from "../../../constants/dictionaries";
import Select from '../../Common/Select'
import Button from '../../../components/Buttons'
import Du_AnModal from './Du_AnModal'
import { FastField } from "formik";
import ValidatedText from "../../Common/ValidatedText";
import helper from '../../../helper/helper'
import Input from '../../Common/Input'
import Api from '../../../api';
import message from "../../Messages";
import Api_quantrac from '../../../api/api.quantrac';


let timeout;
let currentValue;

function fetch(value, callback, user) {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }
  currentValue = value;
  if (value === "null") {
    callback([]);
  } else {
    function fake() {
      new Api_quantrac().GetDMDuAns({ token: user.access_token, page: 0, size: 0, strSearch: currentValue })
        .then(res => {
          if (currentValue === value) {
            callback(res && res.data);
          }
        })
        .catch((err) => message.error(err.message))
    }
    timeout = setTimeout(fake, 800);
  }
}
class Du_An extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      setModal: false,
      data: [],
      timeout: null
    }
  }
  componentDidUpdate = (prevProps) => {
    const { values, mode } = this.props
   
    if (mode === "edit") {
      if (values.duAn_Id) {
        if (values.duAn_Id !== prevProps.values.duAn_Id) {
          this.getDVXCP(values.duAn_Ten)
        }
      }
    }
  };
  componentDidMount = () => {
    const { values, mode } = this.props
    if (mode === "edit") {
      if (values.duAn_Id) {
        this.getDVXCP(values.duAn_Ten)
      }
    }
  }

  getDVXCP = (strSearch) => {
    const { user } = this.props
    new Api_quantrac().GetDMDuAns({ token: user.access_token, page: 0, size: 0, strSearch: strSearch })
      .then(res => {
      
        this.setState({ data: res && res.data })
      })
      .catch((err) => message.error(err.message))
  }
  SelectSearch = value => {
    const { user } = this.props;
    if (value && value !== "" && value !== undefined) {
      fetch(
        value,
        res => this.setState({ data: res }),
        user
      );
    } else {
      fetch(
        "null",
        res => this.setState({ data: res }),
        user
      );
    }
  };
  render() {
    const { setModal, data } = this.state;
    const { values, setFieldValue, handleGP, mode } = this.props
    return (
      <Row>
        <Row type="flex">
          <Col span={21}>
            <Select 
              placeholder={typo.cscore_tt_duan}
              width="100%"
              label={typo.cscore_tt_duan}
              name="tenDuAn"
              name_value="id"
              defaultValue={values.duAn_Id}
              key={values.duAn_Id}
              onSearch={this.SelectSearch}
              onSelect={(value, e) => {
                setFieldValue("duAn_Id", value);
                setFieldValue("duAn_Ten", e.props.children);
                setFieldValue("duAn_DiaDiem", helper.getFieldValueFromID(value, data, "diaChi"));
                handleGP(value)
              }}
              mandatory={false}
              showArrow={false}
              filterOption={false}
              defaultActiveFirstOption={false}
              notFoundContent={null}
              dataSource={data}
              // disabled={mode === "edit" ? true : false}
            />
          </Col>
          <Col span={3}>
            <Row type="flex" align="bottom" style={{ height: "100%", float: "right" }}>
              <Button type="primary" onClick={() => this.setState({ setModal: true })}>
                <Icon style={{ color: '#fff' }} type="plus" />
              </Button>
            </Row>
          </Col>
        </Row>
        <FastField
          name="duAn_DiaDiem"
          render={({ field }) => <Input  placeholder={typo.cscore_dia_chi_du_an} label={typo.cscore_dia_chi_du_an} {...field} mandatory={false} />}
        />

        <Du_AnModal
          handleCancel={() => this.setState({ setModal: false })}
          handleOk={() => {
            this.setState({ setModal: false });
          }}
          isOpen={setModal} />
      </Row>
    )
  };
}
Du_An.propTypes = {
  handleGP: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({
  user: state.oidc.user,
  functions: state.functions
});

export default connect(mapStateToProps)(Du_An);

